import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash'
import { connect } from 'react-redux'

const Back = ({ backTxt }) => (
    <Link to="/360" className="backButton">{ backTxt }</Link>
)

export { Back };
export default connect(
    ({ app }) => {

        let backTxt = _.find(app.texts, { Key: 'back' });
        if(backTxt) backTxt = backTxt.Value

        return {
            backTxt
        }

    }
)(Back);



// WEBPACK FOOTER //
// ./src/components/360Mode/AppartmentView/Back.js